import React, { useState } from "react";
import axios from "axios";
import { base_url } from "../../../Auth/BackendAPIUrl";
import { ConfigToken } from "../../../Auth/ConfigToken";

// Uploads files via the existing /upload-image endpoint (Firebase) and
// stores the returned public URL list in the answer.
export const FileField = ({ question, value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");
  const allowMultiple = !!question.allow_multiple;
  const urls = Array.isArray(value) ? value : value ? [value] : [];

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setError("");
    setUploading(true);
    try {
      const uploaded = [];
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        const cfg = ConfigToken();
        const res = await axios.post(
          `${base_url}/upload-image`,
          fd,
          { ...cfg, headers: { ...(cfg.headers || {}), "Content-Type": "multipart/form-data" } }
        );
        const url = res?.data?.url || res?.data?.firebase_url || res?.data;
        if (url) uploaded.push(url);
      }
      const next = allowMultiple ? [...urls, ...uploaded] : uploaded.slice(-1);
      onChange(allowMultiple ? next : next[0] || "");
    } catch (err) {
      setError("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const removeAt = (idx) => {
    const next = urls.filter((_, i) => i !== idx);
    onChange(allowMultiple ? next : next[0] || "");
  };

  return (
    <div>
      <input
        type="file"
        multiple={allowMultiple}
        onChange={handleFiles}
        disabled={uploading}
      />
      {uploading && <div className="dq-loading">Uploading…</div>}
      {error && <div className="dq-error">{error}</div>}
      {urls.length > 0 && (
        <ul className="dq-file-list">
          {urls.map((u, i) => (
            <li key={`${u}-${i}`}>
              <a href={u} target="_blank" rel="noreferrer">{u}</a>{" "}
              <button type="button" onClick={() => removeAt(i)}>remove</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
